import { render, staticRenderFns } from "./AddNewInvoice.vue?vue&type=template&id=a051d3c4&scoped=true&"
import script from "./AddNewInvoice.vue?vue&type=script&lang=js&"
export * from "./AddNewInvoice.vue?vue&type=script&lang=js&"
import style0 from "./AddNewInvoice.vue?vue&type=style&index=0&id=a051d3c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a051d3c4",
  null
  
)

export default component.exports